import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopCategoryDetails from '../../../components/Shops/Categories/CategoryDetails'

const ShopCategoryPage = (): ReactElement => {
  return (
    <Layout >
      <ShopCategoryDetails />
    </Layout>
  )
}

export default ShopCategoryPage
